// extracted by mini-css-extract-plugin
export default {"section":"style_section__-M4QP","sectionContent":"style_sectionContent__S7mCz"};